<template>
  <data-loader>
    <page-layout>
      <template #header>
        <simulation-header :title="simulation.name + ' - Review'"></simulation-header>
      </template>
      <simulation-review-content
        :flashcard-list-statuses="flashcardListStatuses"
        @navigate="navigate"
      ></simulation-review-content>
      <template #footer>
        <page-footer
          button-text="Finish"
          @next-button-clicked="submitSimulation"
        >
          <template #left-buttons>
            <simulation-review-buttons
              @review="startReview"
            ></simulation-review-buttons>
          </template>
        </page-footer>
      </template>
    </page-layout>
  </data-loader>
</template>

<script>
import DataLoader from '@/components/sims/DataLoader.vue';
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import PageLayout from '@/components/sims/single-section-sim/PageLayout.vue';
import PageFooter from '@components/sims/single-section-sim/PageFooter.vue';
import SimulationHeader from '@components/sims/single-section-sim/SimulationHeader.vue';
import SimulationReviewContent from '@components/sims/single-section-sim/SimulationReviewContent.vue';
import SimulationReviewButtons from '@/components/sims/single-section-sim/SimulationReviewButtons.vue';

export default {
  components: {
    DataLoader,
    PageLayout,
    SimulationHeader,
    PageFooter,
    SimulationReviewButtons,
    SimulationReviewContent,
  },
  mixins: [WuxSimulationsMixin],
  data: () => ({
  }),
  computed: {
  },
  methods: {
    submitSimulation() {
      this.$router.push({
        name: 'sims#outro',
        params: {
          simId: this.simulation.id,
        },
      });
    },
    navigate(flashcardId, filter = 'all') {
      return this.$router.push({
        name: 'simFlashcard#show',
        params: {
          simId: this.simId,
          flashcardId: flashcardId,
        },
        query: {
          filter,
        },
      });
    },
    startReview(filter = 'all') {
      let flashcardId = this.flashcardListStatuses[0].id;

      if (filter === 'all') {
        this.$store.dispatch('flashcardSet/setIds',
          this.flashcardListStatuses.map(status => status.id),
        );
        flashcardId = this.$store.getters['flashcardSet/ids'][0];
      }

      if (filter === 'incomplete') {
        this.$store.dispatch('flashcardSet/setIds',
          this.flashcardListStatuses.filter(status => !status.isAnswered).map(status => status.id),
        );
        flashcardId = this.$store.getters['flashcardSet/ids'][0];
      }

      if (filter === 'flagged') {
        this.$store.dispatch('flashcardSet/setIds',
          this.flashcardListStatuses.filter(status => status.isBookmarked).map(status => status.id),
        );
        flashcardId = this.$store.getters['flashcardSet/ids'][0];
      }

      if (filter === 'incorrect') {
        this.$store.dispatch('flashcardSet/setIds',
          this.flashcardListStatuses.filter(
            status => (status.isAnswered && !status.isCorrect) || !status.isAnswered,
          ).map(status => status.id),
        );
        flashcardId = this.$store.getters['flashcardSet/ids'][0];
      }

      if (!flashcardId) return;
      // When falsy, it's important to pass undefined so that the query string will be empty
      this.navigate(flashcardId, filter ? filter : undefined);
    },
  },
};
</script>
